module.exports = __webpack_public_path__ + "static/media/Card2.ab347a1e.png";